<template>
	<ui-form :model="params.data" :transfer-model.sync="submitData" v-slot="{data}">
		<ui-hidden v-model="data.id" autosubmit/>
		<ui-text v-model="data.count" label="账号"/>
		<ui-text v-model="data.password" type="password" v-if="params.type=='add'" label="密码"/>
		<ui-text v-model="data.email" label="邮箱"/>
		<ui-text v-model="data.mobile" label="手机"/>
		<ui-date v-model="data.createTime" type="date" label="注册时间"/>
		<ui-select v-model="data.status" label="状态">
			<ui-option value="1" text="启用" tag-type="success"/>
			<ui-option value="0" text="禁用" tag-type="info"/>
		</ui-select>
		<ui-template>
			<ui-button type="submit" @submit="submit"></ui-button>
			<ui-button type="reset" v-if="params.type=='add'"></ui-button>
		</ui-template>
	</ui-form>
</template>

<script>
export default {
	props:['params','close'],
	data(){
		return {
			submitData:{}
		};
	},
	methods:{
		submit(){
			this.$axios.request({url:'/admin/sysUser/option',data:this.submitData,method:this.params.type})
			.then(data=>{
				this.close();
			}).end();
		},
	},
}
</script>

<style>
</style>
